module.exports = __webpack_public_path__ + "static/media/water.697243f3.svg";